export const APIURL = process.env.REACT_APP_API_URL || 'https://api.rateauditor.org'
export const recaptcha_sitekey = process.env.REACT_APP_RECAP_KEY
export const TOKEN_NAME = '_ra_auth_token'
export const TITLE = process.env.REACT_APP_TITLE || 'RateAuditPartner'
